// Switcher FR/EN. Conserve le contexte de page via translateRoute().
// Compact (texte uniquement) pour s'intégrer au navbar sans casser la grille de hauteurs.

import { Link, useLocation } from "react-router-dom";
import { translateRoute, type Lang } from "./routes";
import { useLang } from "./useLang";

interface Props {
  className?: string;
  variant?: "navbar" | "footer";
}

const LanguageSwitcher = ({ className = "", variant = "navbar" }: Props) => {
  const { pathname } = useLocation();
  const current = useLang();

  const langs: { code: Lang; label: string }[] = [
    { code: "fr", label: "FR" },
    { code: "en", label: "EN" },
  ];

  if (variant === "footer") {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        {langs.map((l) => (
          <Link
            key={l.code}
            to={translateRoute(pathname, l.code)}
            hrefLang={l.code}
            aria-current={current === l.code ? "true" : undefined}
            className={`text-sm font-semibold ${
              current === l.code ? "text-foreground" : "text-muted-foreground hover:text-foreground"
            }`}
          >
            {l.label}
          </Link>
        ))}
      </div>
    );
  }

  return (
    <div
      className={`inline-flex items-center rounded-full border border-border bg-background/60 p-0.5 ${className}`}
      role="group"
      aria-label="Language"
    >
      {langs.map((l) => (
        <Link
          key={l.code}
          to={translateRoute(pathname, l.code)}
          hrefLang={l.code}
          aria-current={current === l.code ? "true" : undefined}
          className={`px-2.5 py-1 text-xs font-bold rounded-full transition-colors ${
            current === l.code
              ? "bg-foreground text-background"
              : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {l.label}
        </Link>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
